// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2bWNK","footer":"ModalCreateQualiphyProcedure_footer__6sLXZ","additionData":"ModalCreateQualiphyProcedure_additionData__30Zyg"};